import React, {useEffect, useState} from "react";
import axios from "@common/axios";
import {Row} from "antd";
import CircularLoader from "@common/CircularLoader";
import Alert from "@common/Alert";

const Worksheet = props => {
    const {conceptId, mediaId} = props;
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [pdf, setPdf] = useState(null);

    useEffect(() => {
        if (!conceptId || !mediaId) return;

        const fetchWorksheet = async () => {
            setLoading(true);
            setError(null);

            try {
                const response = await axios.get("/web/ui/resource/getWorksheet", {
                    params: {conceptId, mediaId}
                });

                setPdf({
                    title: response.data.title || 'Worksheet',
                    url: response.data.url,
                });
            } catch (error) {
                // display error somewhere.
                setError('ERROR!');
                setLoading(false);
            }
        }

        fetchWorksheet();
    }, [conceptId, mediaId]);

    return (
        <div
            key={`worksheet-${conceptId}-${mediaId}`}
        >
            {error ? (
                <Alert
                    type="error"
                    description={
                        <>{error}</>
                    }
                />
            ) : (
                <>
                    {loading && (
                        <Row>
                            <CircularLoader displayInElement={true}/>
                        </Row>
                    )}
                    {pdf && (
                        <div
                            className="ch-res-worksheet"
                            style={{
                                height: '100vh',
                                display: loading ? 'none' : 'block'
                            }}
                        >
                            <iframe
                                src={`${pdf.url}#toolbar=0`}
                                width="100%"
                                height="100%"
                                title={pdf.title}
                                onLoad={() => setLoading(false)}
                            />
                        </div>
                    )}
                </>
            )}
        </div>
    )
}

export default Worksheet;